import Default from './default';

const Modal = {
  Default,
};

export default Modal;
